import { useQuery } from '@tanstack/react-query'

import { client } from 'src/api/intranet/client.gen'

export const useUserPhoto = (
  scimId: string | null | undefined,
  hasPhoto: boolean
): string | undefined => {
  const { data } = useQuery({
    queryKey: ['userPhoto', scimId],
    enabled: !!scimId && hasPhoto,
    // Create the object URL ONCE and keep it cached for the session. We must not
    // revoke it on component unmount: the same photo is shown by many components
    // and across remounts (e.g. toggling the People grid/list view), and revoking
    // on unmount would blank the avatar everywhere it reappears. Bounded "leak":
    // one URL per distinct user viewed this session.
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
    queryFn: async () => {
      const res = await client.get({
        url: `/users/${scimId}/photo`,
        responseType: 'blob'
      })

      return URL.createObjectURL(res.data as Blob)
    }
  })

  return data ?? undefined
}
